import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function (props) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: "-10%" }}
        animate={{
          opacity: 1,
          x: "0%",
          transition: {
            duration: 0.3,
            delay: 0.16,
          },
        }}
        exit={{
          opacity: 0,
          x: "0%",
          transition: {
            duration: 0.15,
          },
        }}
      >
        <p>{props.text}</p>
      </motion.div>
    </AnimatePresence>
  );
}
